
import React, { forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { Howl, Howler } from "howler";
 import betchipsnd from "../../../assets/sounds/betoncard.mp3";
import betrussiansnd from "../../../assets/sounds/bet.mp3";
import pokerchipsnd from "../../../assets/sounds/pokerchip_snd.mp3";
import plyerwin_snd from "../../../assets/sounds/coinBurstwinSound.mp3";
import cardsdropping_snd from "../../../assets/sounds/carddroping.mp3";
import cardsshuffle from "../../../assets/sounds/shuffle-cards.mp3";
import reaveldealer_cards from "../../../assets/sounds/dealercards_reavel.mp3";
import clear_snd from "../../../assets/sounds/clear.mp3";
import selectCard from "../../../assets/sounds/selectcard.mp3";
import unselectCard from "../../../assets/sounds/unselectcard.mp3";
import playerWin from "../../../assets/sounds/successNew.mp3"
import playerLose from "../../../assets/sounds/successNew.mp3"
import exitSound from "../../../assets/sounds/exit.mp3"
import keno_winSnd from "../../../assets/sounds/keno_win.mp3";

import takeSound from "../../../assets/sounds/take.mp3";
import betSound from "../../../assets/sounds/bet.mp3";
import kenoballsounds from "../../../assets/sounds/keno-loose_3.mp3";
import ballshuffling from "../../../assets/sounds/ballshuffling.mp3";

import winSound from "../../../assets/sounds/win.mp3";
import loseSound from "../../../assets/sounds/duplose.mp3";
import betincreaseSound from "../../../assets/sounds/betoncard.mp3";
const Howlersounds = forwardRef((props, ref) => {
  const soundsRef = useRef({});

  useEffect(() => {
    Howler?.mute(false);
    Howler.volume(1);
    Howler.autoUnlock = true;
    Howler.autoSuspend = false;

    const handleVisibilityChange = (event) => {
      event.preventDefault();
      soundSuspendedChecker();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Initialize all sounds once
    soundsRef.current = {
      pokerchipsnd: new Howl({ src: [pokerchipsnd], preload: true }),
      betchipsnd: new Howl({ src: [betrussiansnd], preload: true }),
      playerWin: new Howl({ src: [plyerwin_snd], preload: true }),
       playerWinbonus: new Howl({ src: [playerWin], preload: true }),
      playerLose: new Howl({ src: [playerLose], preload: true }),
      reavelDealerCards: new Howl({ src: [reaveldealer_cards], preload: true }),
      selectCard: new Howl({ src: [selectCard], preload: true }),
      unselectCard: new Howl({ src: [unselectCard], preload: true }),
      cardShuffle: new Howl({ src: [cardsshuffle], preload: true }),
      clearSnd: new Howl({ src: [clear_snd], preload: true }),
      cardsdropping: new Howl({ src: [cardsdropping_snd], preload: true }),
        exitSoundpokergames: new Howl({ src: [exitSound], preload: true }),

         takeSound: new Howl({ src: [takeSound], preload: true }),
      betSound: new Howl({ src: [betSound], preload: true }),
      kenoballsounds: new Howl({ src: [kenoballsounds], preload: true }),
      ballshuffling: new Howl({ src: [ballshuffling], preload: true }),
      winSound: new Howl({ src: [winSound], preload: true }),
      loseSound: new Howl({ src: [loseSound], preload: true }),
        betincreaseSound: new Howl({ src: [betincreaseSound], preload: true }),
            keno_winSnd: new Howl({ src: [keno_winSnd], preload: true }),

    };

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      Object.values(soundsRef.current).forEach((sound) => {
        sound.stop();
        sound.unload();
      });
    };
  }, []);

  // Expose playSound to parent via ref
  useImperativeHandle(ref, () => ({
    playSound(name) {
      // alert("............."+props.mutesounds)
      
         if (props.mutesounds) return;
      const sound = soundsRef.current[name];
      if (!sound) return console.warn("Sound not found:", name);
      soundSuspendedChecker();
      sound.stop();
      sound.play();
    },
  }));

  const soundSuspendedChecker = () => {
    const tryResumeAudio = () => {
      const ctx = Howler.ctx;
      if (!ctx) return;
  
      const state = ctx.state;
      if (state === 'suspended' || state === 'interrupted') {
        ctx.resume()
          .then(() => {
            Howler._audioUnlocked = true;
            // console.log('✅ Howler audio resumed (state was ' + state + ')');
          })
          .catch(err => {
            console.warn('⚠️ Failed to resume Howler audio:', err, 'state was', state);
          });
      }
    };
  
    /** 🔊 Force iOS to unlock by playing a silent buffer once */
    const forceUnlock = () => {
      try {
        const buffer = Howler.ctx.createBuffer(1, 1, 22050);
        const source = Howler.ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(Howler.ctx.destination);
        source.start(0);
        source.onended = () => {
          source.disconnect();
          Howler._audioUnlocked = true;
        };
      } catch (err) {
        console.warn('⚠️ Silent buffer unlock failed:', err);
      }
    };
  
    // 🟢 Handle iPhone lock/unlock (page visibility + resume)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        // console.log('🔄 Page visible again, trying to resume audio...');
        tryResumeAudio();
        forceUnlock(); // 🔧 ensure hardware wake-up after iPhone unlock
      }
    });
  
    // 🟢 Handle app coming back from background
    window.addEventListener('focus', () => {
      // console.log('🔙 Window focus detected, resuming audio...');
      tryResumeAudio();
      forceUnlock();
    });
  
    // 👆 First user interaction unlocks audio
    const unlockAudio = () => {
      tryResumeAudio();
      forceUnlock();
      window.removeEventListener('touchend', unlockAudio);
      window.removeEventListener('click', unlockAudio);
      window.removeEventListener('touchstart', unlockAudio);
    };
  
    window.addEventListener('touchend', unlockAudio, { once: true, passive: true });
    window.addEventListener('click', unlockAudio, { once: true, passive: true });
    window.addEventListener('touchstart', unlockAudio, { once: true, passive: true });
  
    // 🔁 Periodic safety check (every 3 sec)
    const interval = setInterval(() => {
      const ctx = Howler.ctx;
      if (ctx && (ctx.state === 'suspended' || ctx.state === 'interrupted')) {
        // console.log('⏰ Periodic resume check triggered');
        tryResumeAudio();
        forceUnlock();
      }
    }, 3000);
  
    // 🧹 Optional: store interval to clear later if needed
    window._howlerResumeInterval = interval;
  
    // 🚀 Initial attempt
    tryResumeAudio();
    forceUnlock();
  };
  
  return null;
});

export default Howlersounds;

